import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";
import * as types from "./action-types";
import { AuthActionCreators, IApplicationState } from '../../index';
import { IPost } from '../../authorization/index';
import { IDelete, IPut } from '../../authorization/actions';
import {
    IContactTemp, IGalaContactsListResponse, IContactListResponse,
    IContact, ICenterListResponse, ICenter, IBaseResponse, IContactRequest, IContactResponse
} from '../../../models/index';

export const ActionCreators = {
    getGalaContacts: () => (dispatch: Dispatch<IApplicationState>): Promise<IGalaContactsListResponse> => {
        var options = {
            url: `${__API__}/contact/gala-contacts`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IGalaContactsListResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setGalaContactsList(response.data.results));

            return Promise.resolve(response);
        });
    },
    getContactList: () => (dispatch: Dispatch<IApplicationState>): Promise<IContactListResponse> => {
        var options = {
            url: `${__API__}/contact`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IContactListResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setContactList(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    updateContactTempLink: (contactTempId:number, contactId:number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/contact/link/update/${contactTempId}/${contactId}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getCenterList: () => (dispatch: Dispatch<IApplicationState>): Promise<ICenterListResponse> => {
        var options = {
            url: __API__ + "/center"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ICenterListResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setCenterList(response.data.results));

            return Promise.resolve(response);
        });
    },
    removeContactTempLink: (contactTempId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/contact/link/remove/${contactTempId}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    saveContact: (request: IContactRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IContactResponse> => {
        if (request.id == 0) {
            let options: IPost = {
                url: __API__ + '/contact',
                data: request
            };

            return dispatch(AuthActionCreators.apiPost(options))
                .then((response: IContactResponse) => {
                    return Promise.resolve(response);
                })
                .catch((error: AxiosError) => {
                    throw error;
                });
        } else {
            let options: IPut = {
                url: __API__ + '/contact',
                data: request
            };

            return dispatch(AuthActionCreators.apiPut(options))
                .then((response: IContactResponse) => {
                    return Promise.resolve(response);
                })
                .catch((error: AxiosError) => {
                    throw error;
                });
        }
    },
    resetData: () => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/contact/reset-Temp"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ICenterListResponse) => {
            return Promise.resolve(response);
        });
    },
    setGalaContactsList: (list: IContactTemp[]) => {
        return {
            type: types.SET_GALACONTACTS,
            list
        }
    },
    setContactList: (list: IContact[]) => {
        return {
            type: types.SET_CONTACT_LIST,
            list
        };
    },
    setCenterList: (list: ICenter[]) => {
        return {
            type: types.SET_CENTER_LIST,
            list
        };
    }
}